import { createSelector } from 'reselect';
 
const selectMembershipMemberMappings = (state: any) => state.membershipMemberMappings;
 
export const selectMembershipMemberMappingsCurrentItem = createSelector([selectMembershipMemberMappings], (membershipMemberMappings) => membershipMemberMappings.current);
 
export const selectMembershipMemberMappingsListItems = createSelector([selectMembershipMemberMappings], (membershipMemberMappings) => membershipMemberMappings.list);
 
 
export const selectMembershipMemberMappingsItemById = (itemId: any) =>
    createSelector(selectMembershipMemberMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectMembershipMemberMappingsQueryItems = createSelector([selectMembershipMemberMappings], (membershipMemberMappings) => membershipMemberMappings.query);

export const selectMembershipMemberMappingsCreatedItem = createSelector([selectMembershipMemberMappings], (membershipMemberMappings) => membershipMemberMappings.create);
 
export const selectMembershipMemberMappingsUpdatedItem = createSelector([selectMembershipMemberMappings], (membershipMemberMappings) => membershipMemberMappings.update);
 
export const selectMembershipMemberMappingsReadItem = createSelector([selectMembershipMemberMappings], (membershipMemberMappings) => membershipMemberMappings.read);
 
export const selectMembershipMemberMappingsDeletedItem = createSelector([selectMembershipMemberMappings], (membershipMemberMappings) => membershipMemberMappings.delete);
 
export const selectMembershipMemberMappingsSearchedItems = createSelector([selectMembershipMemberMappings], (membershipMemberMappings) => membershipMemberMappings.search);
 
export const selectMembershipMemberMappingsItemsCount = createSelector([selectMembershipMemberMappings], (membershipMemberMappings) => membershipMemberMappings.count);
 
export const selectMembershipMemberMappingsItemsFilter = createSelector([selectMembershipMemberMappings], (membershipMemberMappings) => membershipMemberMappings.filter);